import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { accRechByYear, accRechByYear_currency } from "@/api/dataAll/accRechgeRink";
import { mapState } from 'vuex';
export default {
  name: "accRechRankByYear",
  mixins: [tabulation],
  data: function data() {
    return {
      more: true,
      searchData: {
        start_year: "",
        end_year: ""
      },
      tableHead: [],
      tableData: [],
      showHeader: [],
      Header: [{
        label: this.$t('nameLabel'),
        prop: 'role_name'
      }, {
        label: this.$t('serverId'),
        prop: 'server_id'
      }, {
        label: this.$t('currentLevel'),
        prop: 'level'
      }, {
        label: this.$t('fightingPower'),
        prop: 'fighting'
      }, {
        label: this.$t('accountTotalRecharge'),
        prop: 'upMoney'
      }, {
        label: this.$t('roleRechargeAmount'),
        prop: 'upMoneyUser'
      }, {
        label: this.$t('userId'),
        prop: 'user_id'
      }, {
        label: this.$t('roleId'),
        prop: 'role_id'
      }, {
        label: this.$t('vipLevel'),
        prop: 'vip'
      }, {
        label: this.$t('lastLoginTime'),
        prop: 'last_login_time'
      }, {
        label: this.$t('userRegisterTimeLabel'),
        prop: 'register_time'
      }],
      HeaderVND: [{
        label: this.$t('nameLabel'),
        prop: 'role_name'
      }, {
        label: this.$t('serverId'),
        prop: 'server_id'
      }, {
        label: this.$t('currentLevel'),
        prop: 'level'
      }, {
        label: this.$t('fightingPower'),
        prop: 'fighting'
      }, {
        label: this.$t('rechargeAmountNew'),
        prop: 'upMoney'
      }, {
        label: this.$t('currencyAmountVnd'),
        prop: 'upMoneyexchange'
      }, {
        label: this.$t('userTotalRechargeAmount'),
        prop: 'upMoneyUser'
      }, {
        label: this.$t('userTotalRechargeAmountVnd'),
        prop: 'upMoneyUserexchange'
      }, {
        label: this.$t('userId'),
        prop: 'user_id'
      }, {
        label: this.$t('roleId'),
        prop: 'role_id'
      }, {
        label: this.$t('vipLevel'),
        prop: 'vip'
      }, {
        label: this.$t('lastLoginTime'),
        prop: 'last_login_time'
      }, {
        label: this.$t('userRegisterTimeLabel'),
        prop: 'register_time'
      }],
      HeaderUSD: [{
        label: this.$t('nameLabel'),
        prop: 'role_name'
      }, {
        label: this.$t('serverId'),
        prop: 'server_id'
      }, {
        label: this.$t('currentLevel'),
        prop: 'level'
      }, {
        label: this.$t('fightingPower'),
        prop: 'fighting'
      }, {
        label: this.$t('rechargeAmountNew'),
        prop: 'upMoney'
      }, {
        label: this.$t('currencyAmountUsd'),
        prop: 'upMoneyexchange'
      }, {
        label: this.$t('userTotalRechargeAmount'),
        prop: 'upMoneyUser'
      }, {
        label: this.$t('userTotalRechargeAmountUsd'),
        prop: 'upMoneyUserexchange'
      }, {
        label: this.$t('userId'),
        prop: 'user_id'
      }, {
        label: this.$t('roleId'),
        prop: 'role_id'
      }, {
        label: this.$t('vipLevel'),
        prop: 'vip'
      }, {
        label: this.$t('lastLoginTime'),
        prop: 'last_login_time'
      }, {
        label: this.$t('userRegisterTimeLabel'),
        prop: 'register_time'
      }]
    };
  },
  created: function created() {
    this.getsearchDate();
  },
  activated: function activated() {// if (this.searchData.game.indexOf(this.royalpirates) > -1) {
    //   this.Header = [
    //     {
    //       label: '名称',
    //       prop: 'role_name'
    //     }, {
    //       label: '服务器ID',
    //       prop: 'server_id'
    //     }, {
    //       label: '当前等级',
    //       prop: 'level'
    //     },{
    //       label: '战斗力',
    //       prop: 'fighting'
    //     }, {
    //       label: '用户ID',
    //       prop: 'user_id'
    //     }, {
    //       label: '角色ID',
    //       prop: 'role_id'
    //     }, {
    //       label: '充值金额',
    //       prop: 'upMoney'
    //     }, {
    //       label: 'VIP等级',
    //       prop: 'vip'
    //     }, {
    //       label: '最后登录时间',
    //       prop: 'last_login_time'
    //     }
    //   ]
    // } else {
    //   this.Header = [
    //     {
    //       label: '用户ID',
    //       prop: 'user_id'
    //     }, {
    //       label: '充值金额',
    //       prop: 'upMoney'
    //     }
    //   ]
    // }
  },
  computed: _objectSpread({}, mapState('d2admin/serchSelect', ['royalpirates'])),
  methods: {
    getsearchDate: function getsearchDate() {
      var now = new Date(this.$times.zeroTimeZone());
      var year = now.getFullYear();
      this.searchData.start_year = year.toString();
      this.searchData.end_year = year.toString();
    },
    rowClick: function rowClick(row, item, prop) {
      if (prop.indexOf('user_id') > -1 && row[prop]) {
        this.$router.replace({
          name: 'orderDisplay',
          params: {
            user_id: row[prop],
            date: item.label,
            type: 'Y'
          }
        });
      }
    },
    searchClick: function searchClick(nums) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var numing, reqFn;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // if(this.currencyClose && !this.searchData.currency_info){
                //   this.$message.error('请选择货币类型')
                //   return
                // }
                numing = nums;
                _this.searchData.start_year = _this.searchData.start_year ? _this.searchData.start_year : '';
                _this.searchData.end_year = _this.searchData.end_year ? _this.searchData.end_year : '';

                if (!(!_this.searchData.start_year || !_this.searchData.end_year)) {
                  _context.next = 6;
                  break;
                }

                _this.$message({
                  type: 'error',
                  message: _this.$t('yearSelectError')
                });

                return _context.abrupt("return");

              case 6:
                _this.reqLoading = true;
                reqFn = _this.currencyClose ? accRechByYear_currency : accRechByYear;
                _context.next = 10;
                return _this.getexchangeRate();

              case 10:
                if (_this.queryCurrency == 'VND') {
                  _this.showHeader = _this.HeaderUSD;
                } else if (_this.queryCurrency == 'USD') {
                  _this.showHeader = _this.Header;
                } else {
                  _this.showHeader = _this.Header;
                }

                reqFn(_objectSpread(_objectSpread({}, _this.searchData), _this.defaultData())).then(function (res) {
                  if (res.status == 200) {
                    _this.resData = res.data;
                    _this.tableHead = [];
                    var data = [];
                    var pageData = Object.keys(res.data).map(function (item) {
                      return _objectSpread({
                        week: item
                      }, res.data[item]);
                    });
                    pageData.forEach(function (i) {
                      for (var k in i) {
                        if (k != 'week') {
                          (function () {
                            var list = [];
                            var userIds = [];
                            i[k].forEach(function (j, ji) {
                              if (j.role_id instanceof Array) {
                                userIds.push(j.user_id);
                                j.role_id.forEach(function (l, li) {
                                  list.push({
                                    user_id: j.user_id,
                                    channel: j.channel,
                                    role_id: j.role_id[li],
                                    server_id: j.server_id[li],
                                    fighting: j.fighting[li],
                                    last_login_time: j.last_login_time[li],
                                    real_time_amount: j.real_time_amount[li],
                                    level: j.level[li],
                                    recharge_amount: j.recharge_amount[li],
                                    role_name: j.role_name[li],
                                    vip: j.vip[li]
                                  });
                                });
                              }
                            });
                            i[k] = i[k].filter(function (obj) {
                              return !userIds.includes(obj.user_id);
                            });
                            i[k] = [].concat(_toConsumableArray(i[k]), list);
                          })();
                        }
                      }
                    });
                    pageData.forEach(function (item, index) {
                      _this.tableHead.push({
                        label: item.week,
                        list: _this.showHeader.map(function (i) {
                          return {
                            label: i.label,
                            prop: "".concat(index + i.prop)
                          };
                        })
                      });

                      var keys = Object.keys(item).filter(function (key) {
                        return key !== 'week';
                      }).sort(function (a, b) {
                        // 提取 key 中的数字部分（如从 "A_95800" 中提取 95800）
                        var numA = Number(a.slice(2));
                        var numB = Number(b.slice(2));
                        return numB - numA; // 数字倒序
                      });
                      var IN = -1;
                      keys.forEach(function (key) {
                        // if (i != 'week') {
                        item[key].forEach(function (k, ki) {
                          IN += 1;
                          var taskData = {};

                          _this.showHeader.forEach(function (j, ji) {
                            var Money = Number(key.slice(2));
                            var ks = k[j.prop];

                            if (j.prop == 'upMoney') {
                              taskData[index + j.prop] = _this.isyjfmvnd() ? Number(Money).toFixed(3) : _this.$utils.conversion(Money);
                            } else if (j.prop == 'upMoneyexchange') {
                              taskData[index + j.prop] = _this.isyjfmvnd() ? (Money * _this.exchangeRate).toFixed(3) : _this.$utils.conversion(Money * _this.exchangeRate).toFixed(2);
                            } else if (j.prop == 'upMoneyUser') {
                              taskData[index + j.prop] = _this.isyjfmvnd() ? k.real_time_amount : _this.$utils.conversion(k.real_time_amount);
                            } else if (j.prop == 'upMoneyUserexchange') {
                              taskData[index + j.prop] = _this.isyjfmvnd() ? Number(k.real_time_amount * _this.exchangeRate).toFixed(2) : _this.$utils.conversion(k.real_time_amount * _this.exchangeRate).toFixed(2);
                            } else {
                              taskData[index + j.prop] = ks instanceof Array ? ks.toString() : ks;
                            }

                            if (k.recharge_amount && k.recharge_amount instanceof Array) {
                              if (j.prop.indexOf('upMoney') > -1) {
                                var list = [];
                                var listexchange = [];
                                k.recharge_amount.map(function (s) {
                                  list.push(_this.isyjfmvnd() ? Number(s).toFixed(3) : _this.$utils.conversion(s));
                                  listexchange.push(_this.isyjfmvnd() ? (Number(s) * _this.exchangeRate).toFixed(2) : _this.$utils.conversion(Number(s) * _this.exchangeRate).toFixed(2));
                                });
                                taskData[index + j.prop] = list.toString();
                                taskData[index + 'upMoneyexchange'] = listexchange.toString();
                              }
                            }

                            if (k.real_time_amount && k.real_time_amount instanceof Array) {
                              if (j.prop.indexOf('upMoneyUser') > -1) {
                                var _list = [];
                                var _listexchange = [];
                                k.real_time_amount.map(function (s) {
                                  _list.push(_this.isyjfmvnd() ? Number(s).toFixed(3) : _this.$utils.conversion(s));

                                  _listexchange.push(_this.isyjfmvnd() ? (Number(s) * _this.exchangeRate).toFixed(2) : _this.$utils.conversion(Number(s) * _this.exchangeRate).toFixed(2));
                                });
                                taskData[index + j.prop] = _list.toString();
                                taskData[index + 'upMoneyUserexchange'] = _listexchange.toString();
                              }
                            }
                          });

                          data[IN] = _objectSpread(_objectSpread({}, data[IN]), taskData);
                        }); // }
                      });
                    });
                    _this.tableData = data;
                    console.log("this.tableData==", _this.tableData);

                    _this.$nextTick(function () {
                      _this.getTableRight();
                    });
                  }
                }).finally(function () {
                  _this.reqLoading = false;
                });

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    exportdata: function exportdata() {
      var _this2 = this;

      var pageData = _objectSpread({}, this.resData);

      pageData = Object.keys(pageData).map(function (item) {
        return _objectSpread({
          week: item
        }, pageData[item]);
      });
      pageData.forEach(function (i) {
        for (var k in i) {
          if (k != 'week') {
            (function () {
              var list = [];
              var userIds = [];
              i[k].forEach(function (j, ji) {
                if (j.role_id instanceof Array) {
                  userIds.push(j.user_id);
                  j.role_id.forEach(function (l, li) {
                    list.push({
                      user_id: j.user_id,
                      channel: j.channel,
                      role_id: j.role_id[li],
                      server_id: j.server_id[li],
                      fighting: j.fighting[li],
                      last_login_time: j.last_login_time[li],
                      real_time_amount: j.real_time_amount[li],
                      level: j.level[li],
                      recharge_amount: j.recharge_amount[li],
                      role_name: j.role_name[li],
                      vip: j.vip[li]
                    });
                  });
                }
              });
              i[k] = i[k].filter(function (obj) {
                return !userIds.includes(obj.user_id);
              });
              i[k] = [].concat(_toConsumableArray(i[k]), list);
            })();
          }
        }
      });
      var columns = [];
      var data = [{}];
      var merges = [];
      var complete = {};
      pageData.map(function (item, index) {
        columns.push.apply(columns, _toConsumableArray(_this2.showHeader.map(function (i, ins) {
          return {
            label: ins == 0 ? _this2.$t('yearLabel', {
              year: item.week
            }) : '',
            prop: "".concat(index + i.prop)
          };
        })));

        _this2.showHeader.forEach(function (i) {
          complete[index + i.prop] = i.label;
        });

        var IN = -1;

        var _loop = function _loop(i) {
          if (i != 'week') {
            item[i].forEach(function (k, ki) {
              IN += 1;
              var taskData = {};

              _this2.showHeader.forEach(function (j, ji) {
                var Money = Number(i.slice(2));
                var ks = k[j.prop];

                if (j.prop == 'upMoney') {
                  taskData[index + j.prop] = _this2.isyjfmvnd() ? Number(Money).toFixed(3) : _this2.$utils.conversion(Money);
                } else if (j.prop == 'upMoneyexchange') {
                  taskData[index + j.prop] = _this2.isyjfmvnd() ? (Money * _this2.exchangeRate).toFixed(3) : _this2.$utils.conversion(Money * _this2.exchangeRate).toFixed(2);
                } else if (j.prop == 'upMoneyUser') {
                  taskData[index + j.prop] = _this2.isyjfmvnd() ? k.real_time_amount : _this2.$utils.conversion(k.real_time_amount);
                } else if (j.prop == 'upMoneyUserexchange') {
                  taskData[index + j.prop] = _this2.isyjfmvnd() ? Number(k.real_time_amount * _this2.exchangeRate).toFixed(2) : _this2.$utils.conversion(k.real_time_amount * _this2.exchangeRate).toFixed(2);
                } else {
                  taskData[index + j.prop] = ks instanceof Array ? ks.toString() : ks;
                }

                if (k.recharge_amount && k.recharge_amount instanceof Array) {
                  if (j.prop.indexOf('upMoney') > -1) {
                    var list = [];
                    var listexchange = [];
                    k.recharge_amount.map(function (s) {
                      list.push(_this2.isyjfmvnd() ? Number(s).toFixed(3) : _this2.$utils.conversion(s));
                      listexchange.push(_this2.isyjfmvnd() ? (Number(s) * _this2.exchangeRate).toFixed(2) : _this2.$utils.conversion(Number(s) * _this2.exchangeRate).toFixed(2));
                    });
                    taskData[index + j.prop] = list.toString();
                    taskData[index + 'upMoneyexchange'] = listexchange.toString();
                  }
                }

                if (k.real_time_amount && k.real_time_amount instanceof Array) {
                  if (j.prop.indexOf('upMoneyUser') > -1) {
                    var _list2 = [];
                    var _listexchange2 = [];
                    k.real_time_amount.map(function (s) {
                      _list2.push(_this2.isyjfmvnd() ? Number(s).toFixed(3) : _this2.$utils.conversion(s));

                      _listexchange2.push(_this2.isyjfmvnd() ? (Number(s) * _this2.exchangeRate).toFixed(2) : _this2.$utils.conversion(Number(s) * _this2.exchangeRate).toFixed(2));
                    });
                    taskData[index + j.prop] = _list2.toString();
                    taskData[index + 'upMoneyUserexchange'] = _listexchange2.toString();
                  }
                }
              });

              data[IN] = _objectSpread(_objectSpread({}, data[IN]), taskData);
            });
          }
        };

        for (var i in item) {
          _loop(i);
        }
      }); // for (let n = 0; n < parseInt(columns.length / 2); n++) {
      //   merges.push([this.headerZh(n, 0), this.headerZh(n, 1)])
      // }

      data.unshift(complete);
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title,
        merges: merges
      });
    },
    headerZh: function headerZh(index, nIndex) {
      var k = parseInt(index / 13);
      var letterTable = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
      var num = k > 0 ? letterTable[k - 1] : '';

      if (k < 1) {
        if (nIndex == 0) {
          num = num + letterTable[k <= 1 ? index * 2 : index];
        } else {
          num = num + letterTable[k <= 1 ? index * 2 + 1 : index + 1];
        }
      } else {
        if (nIndex == 0) {
          num = num + letterTable[index % 13 * 2];
        } else {
          num = num + letterTable[index % 13 * 2 + 1];
        }
      }

      return num + '1';
    }
  }
};